module.exports = __webpack_public_path__ + "static/media/illuminate-3.06342fff.png";